import styled from 'styled-components';

const Root = styled.div`
    display: inline-flex;
    position: relative;

    > svg {
        width: 100%;
        height: auto;
    }
`;

export { Root };
